<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'app-sidebar',
    computed: {
      ...mapGetters(['isLogged', 'currentUser', 'permissions', 'collapseMenu'])
    },
    data () {
      return {
        activeIndex: '',
        menu: [
          {
            domain: 'event',
            name: 'Eventos',
            icon: 'fa fa-calendar',
            children: [],
            permission: false
          },
          {
            domain: '1',
            name: 'Conf Inscrições',
            icon: 'fa fa-window-maximize',
            permission: false,
            children: [
              {
                domain: 'literacy',
                name: 'Escolaridade',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'modality',
                name: 'Modalidades',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'registration_status',
                name: 'Status de Inscrição',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'place',
                name: 'Endereços',
                icon: 'fa fa-file-o',
                permission: false
              }
            ]
          },
          {
            domain: '2',
            name: 'Trabalhos',
            icon: 'fa fa-window-maximize',
            permission: false,
            children: [
              {
                domain: 'layout',
                name: 'Layout Certificados',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'signature',
                name: 'Assinatura Certificados',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'field',
                name: 'Campos',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'criteria',
                name: 'Critérios',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'paper_type',
                name: 'Tipo de Trabalhos',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'paper_status',
                name: 'Status Trabalhos',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'evaluation_type',
                name: 'Tipo de Avaliação',
                icon: 'fa fa-file-o',
                permission: false
              }
            ]
          },
          {
            domain: '3',
            name: 'Administração',
            icon: 'fa fa-window-maximize',
            permission: false,
            children: [
              {
                domain: 'role',
                name: 'Perfis de Usuário',
                icon: 'fa fa-file-o',
                permission: false
              },
              {
                domain: 'user',
                name: 'Usuários',
                icon: 'fa fa-file-o',
                permission: false
              }
            ]
          }
        ]
      }
    },
    mounted () {
      window.addEventListener('resize', this.handleResize)
      this.menu.forEach(menu => {
        menu.children.forEach(child => {
          child.permission = this.hasPermission(child.domain + '.index') || this.hasPermission(child.domain + '.search')
        })
        if (menu.children.length === 0) {
          menu.permission = this.hasPermission(menu.domain + '.index') || this.hasPermission(menu.domain + '.search')
        } else {
          menu.permission = !menu.children.some(child => !child.permission)
        }
      })
    },
    watch: {
      '$route.name': function (name) {
        this.activeIndex = name
      }
    },
    methods: {
      ...mapActions(['setCollapseMenu']),
      handleResize () {
        this.setCollapseMenu(document.documentElement.clientWidth < 1400)
      },
      hasPermission (permission) {
        return this.permissions.some((item) => {
          return item.name === permission
        })
      }
    }
  }
</script>

<template>
    <div class="app-sidebar" v-bind:class="{'-is-collapse-menu-active': collapseMenu}">
        <el-menu :default-active="activeIndex"
                 :router="true"
                 :collapse="collapseMenu"
                 background-color="#222d32"
                 text-color="#fff">
            <el-menu-item v-for="item in menu"
                          v-if="item.children.length === 0 && item.permission"
                          :route="{ name: item.domain + '.index' }"
                          :index="item.domain + '.index'"
                          :title="item.name">
                <i v-bind:class="item.icon"></i>
                <span>{{item.name}}</span>
            </el-menu-item>
            <el-submenu v-for="item in menu"
                        v-if="item.children.length > 0 && item.permission"
                        :index="item.domain">
                <template slot="title">
                    <i v-bind:class="item.icon"></i>
                    <span>{{item.name}}</span>
                </template>
                <el-menu-item v-for="child in item.children"
                              v-if="child.permission"
                              :route="{name: child.domain + '.index'}"
                              :index="child.domain + '.index'"
                              :title="child.name">
                    <i v-bind:class="child.icon"></i>
                    <span>{{child.name}}</span>
                </el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
</template>



// WEBPACK FOOTER //
// Sidebar.vue?618c9e1e